import ActionSubmit, { ActionSubmitBlock } from './components/ActionSubmit';
export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelActionSubmitCategory } = opts;
  ActionSubmitBlock(bm, labelActionSubmitCategory, labels.actionSubmit, types.actionSubmit);
  ActionSubmit(dc, labels.actionSubmit, types.actionSubmit, opts);
};
